module.exports = __webpack_public_path__ + "static/media/LoginBackground.7dedef41.jpg";